export default "__VITE_ASSET__FZQVExOZ__"